import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const ClusterIcon = createSvgIcon(
 <svg
  fill="currentColor"
  version="1.1"
  id="Capa_1"
  xmlns="http://www.w3.org/2000/svg"
  width="800px"
  height="800px"
  viewBox="0 0 612.001 612.002"
  xmlSpace="preserve">
  <g>
   <path
    d="M528.21,343.042l-28.7,41.342H155.48l-12.641-27.067c-3.66-7.837-11.526-12.845-20.176-12.845h-4.093v-90.698
       c0-3.31-1.887-7.962-4.191-10.338l-16.7-17.209c-2.405-2.479-7.199-4.507-10.653-4.507H52.729c-3.323,0-7.987,1.898-10.365,4.218
       l-17.889,17.448c-2.464,2.403-4.48,7.186-4.48,10.627v90.458H7.431c-5.316,0-8.909,5.425-6.834,10.319l41.464,97.827
       c5.826,13.745,19.319,22.661,34.248,22.63l426.109-0.894c12.53-0.026,24.201-6.374,31.033-16.878l77.338-118.913
       c3.212-4.938-0.332-11.469-6.223-11.469h-45.868C546.536,327.095,535.146,333.052,528.21,343.042z M80.177,260.517h23.647v15.917
       H80.177V260.517z M80.177,306.516h23.647v15.918H80.177V306.516z M36.292,260.517H59.94v15.917H36.292V260.517z M36.292,306.516
       H59.94v15.918H36.292V306.516z M229.04,326.854l66.092,40.923c-2.96,1.531-6.269,2.479-9.831,2.479H175.918
       c-4.242,0-8.17-1.27-11.503-3.388L229.04,326.854z M371.846,239.189H262.464c-4.243,0-8.171-1.269-11.504-3.388l64.625-40.014
       l66.092,40.922C378.717,238.242,375.408,239.189,371.846,239.189z M350.161,370.257c-4.242,0-8.171-1.27-11.504-3.388
       l64.625-40.015l66.092,40.923c-2.959,1.531-6.268,2.479-9.831,2.479H350.161L350.161,370.257z M304.271,358.699l-63.331-39.213
       l63.694-39.438c1.361,2.824,2.19,5.952,2.19,9.296v59.389C306.825,352.351,305.847,355.708,304.271,358.699z M415.182,319.486
       l63.694-39.438c1.362,2.824,2.19,5.952,2.19,9.296v59.389c0,3.616-0.977,6.974-2.554,9.966L415.182,319.486z M330.401,357.245
       c-1.128-2.612-1.764-5.485-1.764-8.512v-59.388c0-2.751,0.563-5.359,1.504-7.777l61.241,37.918L330.401,357.245z M229.04,312.119
       l-65.349-40.462c3.476-2.408,7.68-3.835,12.227-3.835h109.383c3.875,0,7.46,1.105,10.601,2.897L229.04,312.119z M242.703,226.178
       c-1.127-2.612-1.763-5.486-1.763-8.511v-59.388c0-2.751,0.563-5.359,1.504-7.777l61.24,37.918L242.703,226.178z M156.158,357.245
       c-1.126-2.612-1.764-5.485-1.764-8.512v-59.388c0-2.751,0.564-5.359,1.505-7.777l61.24,37.918L156.158,357.245z M315.585,181.051
       l-65.349-40.461c3.476-2.408,7.68-3.836,12.227-3.836h109.382c3.876,0,7.46,1.105,10.601,2.898L315.585,181.051z M350.161,267.821
       h109.382c3.876,0,7.461,1.105,10.601,2.898l-66.862,41.399l-65.348-40.462C341.41,269.25,345.614,267.821,350.161,267.821z
        M327.486,188.42l63.694-39.438c1.361,2.825,2.19,5.952,2.19,9.297v59.388c0,3.618-0.978,6.975-2.554,9.966L327.486,188.42z"
   />
  </g>
 </svg>,
 "Cluster"
);
